import React, { useEffect, useState } from 'react'
import ShuffleText from 'react-shuffle-text';
import Rewords from "./Rewords";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import Ztext from 'react-ztext';
import { gameStatusState } from '../../globalStates/general/gameStatus';
import { useRecoilState, useRecoilValue } from 'recoil';
import { userDataState } from '../../globalStates/general/userData';
import { getUserData } from '../../database/getUserData';
import { Link } from 'react-router-dom';
import { pointerWithin } from '@dnd-kit/core';
import { getOwnRank } from '../../database/pointRank';
import { auth } from '../../database/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { thisGamePointState } from '../../globalStates/general/thisGameGetPoint';
import ItemLoad from './ItemLoad';
import CorrectAreaLoading from './CorrectAreaLoading';
import { donotHaveItemArr } from '../GameMain/Item/manageItemData';
import { levelState } from '../../globalStates/general/level';
import { useMedia } from 'use-media';

const CorrectPage = (props) => {

  const [getPointInfo, setGetPointInfo] = useState("");
  const [totalPointInfo, setTotalPointInfo] = useState("");
  const [rankInfo, setRankInfo] = useState("");
  const [correctAreaDisplay, setCorrectAreaDisplay] = useState("none"); // when Player submit the correct answer, this state to become a "block"
  const [gameStatusValue, setGameStatusValue] = useRecoilState(gameStatusState);
  const [userData, setUserData] = useRecoilState(userDataState);
  const [user, initialising] = useAuthState(auth);
  const thisGamePoint = useRecoilValue(thisGamePointState);
  const [isLoading, setIsLoading] = useState("");
  const [donotHaveItemList, setdonotHaveItemList] = useState([]);
  const [level, setLevel] = useRecoilState(levelState);




  useEffect(() => {
    setCorrectAreaDisplay("none");
    if (props.judgeResulut) {
      // correct
      setGameStatusValue(6) // set game clear status
      setIsLoading(true);
      setCorrectAreaDisplay("block");
    }

  }, [props.judgeResulut]);


  const fetchItemList = async () => {
    if (gameStatusValue === 7) {
      // donotHaveItemArr(): from manage item
      // format: [i, itemData[i].name, itemData[i].needPoint]
      if (level === "self") {
        setdonotHaveItemList(await donotHaveItemArr("normal"));
      } else {
        setdonotHaveItemList(await donotHaveItemArr(level));
      }
      setIsLoading(false);
    } else {
      return;
    }
  };

  useEffect(() => {
    if (gameStatusValue === 7) {
      (async () => {
        await fetchItemList();
        setGetPointInfo(`今回のクエストで${thisGamePoint}ポイントを獲得しました。`);
        setTotalPointInfo(`トータル: ${userData.totalPoint}ポイント`);
        setTimeout(() => {
          getOwnRank(user.uid).then((rank) => {
            setRankInfo("全体順位は" + rank + "位です。");
          });

        }, 1500);

      })()

    }
  }, [userData, thisGamePoint]);
  const isPC = useMedia({ minWidth: '1000px' });
  const correctArea = css`
    display: ${correctAreaDisplay};
    position: absolute;
    top: 0;
    left: 0;
    background-color: #fff;
    width: 100vw;
    height: 100vh;
    text-align: center;
    padding-top: ${isPC ? "20vh" : "5vh"};
    z-index: 2;
    .user-info {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translateX(-50%);
      font-size: 1.5em;
      color: #555555;
    }
    button {
      border: none;
      position: absolute;
      background-color: #fff;

      left: 50%;
      bottom: ${isPC ? "25vh" : "15vh"};
      transform: translateX(-50%);

      text-align: center;
      a {
        font-size: 1.5em;
        color: #555555;
      }
    }

    `;


  sessionStorage.setItem('url', window.location.href);
  return (
    <>
      {isLoading ? (
        <CorrectAreaLoading props={isLoading} />
      ) :
        (
          <div css={correctArea}>
            <ItemLoad donotHaveItemArr={donotHaveItemList} />
            {
              isPC ? (
                <Ztext
                  depth='1rem'
                  direction='both'
                  event='pointer'
                  eventRotation='30deg'
                  eventDirection='default'
                  fade={false}
                  layers={10}
                  perspective='500px'
                  style={{
                    fontSize: '7rem',
                    // fontWeight: "bold",
                    color: '#181818',
                  }}
                >

                  <span role='img' aria-label='emoji'>
                    🎉
                    {/*  <ShuffleText content="Perfect!!" /> */}
                  </span>
                </Ztext>
              ) : (
                <Ztext
                  depth='1rem'
                  direction='both'
                  event='pointer'
                  eventRotation='30deg'
                  eventDirection='default'
                  fade={false}
                  layers={10}
                  perspective='500px'

                  style={{
                    fontSize: '5rem',
                    // fontWeight: "bold",
                    color: '#181818',
                  }}
                >

                  <span role='img' aria-label='emoji'>
                    🎉
                    {/*  <ShuffleText content="Perfect!!" /> */}
                  </span>
                </Ztext>
              )

            }

            <Rewords isCorrect={props.judgeResulut} />
            <div className="user-info">
              <ShuffleText content={
                `${getPointInfo}`
              } /> <br />
              <ShuffleText content={
                `${totalPointInfo}`
              } /> <br />
              <ShuffleText content={
                `${rankInfo}`
              } />
            </div>
            <button>
              <a href="/">ホーム</a>
            </button>

          </div>
        )
      }
    </>
  )
}

export default CorrectPage
